const domMixin = {
  methods: {
    copyTableToClipboard ($table) {
      const el = $table.querySelector('table')

      let body = document.body
      let range = null
      let sel = null

      if (document.createRange && window.getSelection) {
        range = document.createRange()
        sel = window.getSelection()
        sel.removeAllRanges()
        try {
          range.selectNodeContents(el)
          sel.addRange(range)
        } catch (e) {
          range.selectNode(el)
          sel.addRange(range)
        }
        document.execCommand('copy')
      } else if (body.createTextRange) {
        range = body.createTextRange()
        range.moveToElementText(el)
        range.select()
        range.execCommand('Copy')
      }

      this.$store.commit('snackbar/SHOW_SNACKBAR', {text: 'Copied to clipboard'})

      this.$_domMixin_clearSelection()
    },

    $_domMixin_clearSelection () {
      if (document.selection) {
        document.selection.empty()
      } else if (window.getSelection) {
        window.getSelection().removeAllRanges()
      }
    }
  }
}

export default domMixin



// WEBPACK FOOTER //
// ./src/mixins/dom.js